import React from "react";
import { FormattedChatMessage } from "../../app/types";
import AttendeeAvatar from "../attendeeList/AttendeeAvatar";
import LightTheme from "../theme/LightTheme";

interface Props {
  question: FormattedChatMessage;
}

const ChatQuestionRow = ({ question }: Props) => (
  <div className="questionWrapper">
    <div className="questionContainer">
      <AttendeeAvatar
        name={question.user.name as string}
        url={question.user.avatar as string | undefined}
      />
      <div className="messageContainer">
        <span className="nameText">{question.user.name}</span>
        <span className="messageMain">{question.text}</span>
      </div>
    </div>
    <style jsx>{`
      .questionWrapper {
        display: flex;
        flex-direction: column;
        padding: 0 10px 0 0;
      }
      .questionContainer {
        display: flex;
        align-items: flex-start;
        padding: 10px 0;
      }
      .messageContainer {
        display: flex;
        flex-direction: column;
        padding: 0 0 0 10px;
      }
      .nameText {
        font-weight: bold;
        font-size: 0.8rem;
        color: #343434;
        padding: 0 0 10px 0;
      }
      .messageMain {
        font-size: 0.8rem;
        color: ${LightTheme.font.secondary.color};
      }
    `}</style>
  </div>
);

export default ChatQuestionRow;
